'use strict';

/**
 * 同意チェックによるサブミットボタンの活性化制御
 */

module.exports = function () {
    const $agree = $('#privacy-policy-agree');
    const $submit = $agree.closest('form').find('.m-formSubmit');
    $agree.on('change', function() {
        if ($agree.is(':checked')) {
            $submit.removeAttr('disabled');
        } else {
            $submit.attr('disabled', 'disabled');
        }
    });
};
